// extracted by mini-css-extract-plugin
export default {"root":"Card_root__hz3aS","image":"Card_image__ZlhbW","values":"Card_values__+CpWE","dragging":"Card_dragging__ykJVG","p1":"Card_p1__IRCix","p2":"Card_p2__i0ctV"};